import {
  Flex,
  PrimaryButton,
  TextButton,
  Typography,
  useSafeArea,
} from '@banhala/ui-kit';
import { useAtomValue } from 'jotai';
import { useNavigator } from 'shared/src/utils';
import { useMyPersonalizationSizeAtoms } from '../../state';
import { useLogClickCta } from '../../hooks/useLogClickCta';

export const SizeContentFooter = () => {
  const { bottom: safeAreaBottom } = useSafeArea();

  const { navigator } = useNavigator();
  const logClickCtaFromOrder = useLogClickCta('SIZE_FROM_ORDER');
  const logClickCtaInput = useLogClickCta('SIZE_INPUT');
  const logClickCtaUpload = useLogClickCta('SIZE_UPLOAD');

  const { selectedProductCategoryAtom } = useMyPersonalizationSizeAtoms();
  const selectedProductCategory = useAtomValue(selectedProductCategoryAtom);

  const handleOpenInputFromOrder = () => {
    logClickCtaFromOrder();
    navigator.moveToWebview(
      `/mypage/size/input?product_category_sno=${selectedProductCategory.product_category_sno}&initial_tab_index=0`,
    );
  };
  const handleOpenInputManually = () => {
    logClickCtaInput();
    navigator.moveToWebview(
      `/mypage/size/input?product_category_sno=${selectedProductCategory.product_category_sno}&initial_tab_index=1`,
    );
  };
  const handleOpenUploadSizeChart = () => {
    logClickCtaUpload();
    navigator.moveToWebview(
      `/mypage/size/input?product_category_sno=${selectedProductCategory.product_category_sno}&initial_tab_index=2`,
    );
  };

  return (
    <Flex
      backgroundColor="bg_always_white"
      borderColor="border_tertiary"
      borderTopWidth={1}
      padding={{ horizontal: 16, top: 16, bottom: safeAreaBottom + 16 }}
      gap={8}
    >
      <PrimaryButton
        variant="fill"
        color="gray"
        size="xlarge"
        onPress={handleOpenInputFromOrder}
      >
        구매 상품으로 사이즈 입력하기
      </PrimaryButton>
      <Flex.Row alignItems="center" justifyContent="center" gap={4}>
        <TextButton
          size="small"
          color="gray"
          decoration="underline"
          onPress={handleOpenInputManually}
        >
          사이즈 직접 입력
        </TextButton>
        <Typography type="body2" color="border_tertiary">
          |
        </Typography>
        <TextButton
          size="small"
          color="gray"
          decoration="underline"
          onPress={handleOpenUploadSizeChart}
        >
          사이즈표 업로드
        </TextButton>
      </Flex.Row>
    </Flex>
  );
};
